import { BrowserRouter } from 'react-router-dom'
import './App.css'
import RouterMain from './routers/RouterMain';



function App() {


  return (
    <>
      <div>
        <BrowserRouter>
          <RouterMain />
        </BrowserRouter>
      </div>
    </>
  );
}

export default App
